import { isApiError, NETWORK_ERROR } from '../api/client';
import type { DictKey } from '../i18n/uk';

/** API error → a dictionary key with a human explanation. Raw server text is never shown. */
export function describeError(e: unknown): DictKey {
  if (!isApiError(e)) return 'err.generic';
  if (e.code === NETWORK_ERROR) return 'err.network';
  if (e.status === 429) return 'err.rate_limited';
  if (e.status === 401) return 'err.unauthorized';
  if (e.status === 403) return 'err.forbidden';
  if (e.status === 404) return 'err.not_found';
  // vehicle without a mandatory document: say so, instead of the generic «cannot be done now»
  if (e.code === 'vehicle_documents') return 'err.vehicle_documents';
  if (e.code === 'vehicle_documents_departure') return 'err.vehicle_documents_departure';
  if (e.status === 409) return 'err.conflict';
  if (e.status === 422) return 'err.validation';
  return 'err.generic';
}

export function isNetworkError(e: unknown): boolean {
  return isApiError(e) && e.code === NETWORK_ERROR;
}
